import { render, staticRenderFns } from "./addFeishu.vue?vue&type=template&id=48268001&scoped=true"
import script from "./addFeishu.vue?vue&type=script&lang=js"
export * from "./addFeishu.vue?vue&type=script&lang=js"
import style0 from "./addFeishu.vue?vue&type=style&index=0&id=48268001&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48268001",
  null
  
)

export default component.exports